// extracted by mini-css-extract-plugin
export var wrapperheader = "Header-module--wrapperheader--38nXV";
export var wrapperLogoPhone = "Header-module--wrapperLogoPhone--hvPV4";
export var img = "Header-module--img--3diTv";
export var wrapperLogo = "Header-module--wrapperLogo--3pQDc";
export var wrapperMenu = "Header-module--wrapperMenu--36Nif";
export var Hamburgermenu = "Header-module--Hamburgermenu--3N_wn";
export var wrapperNav = "Header-module--wrapperNav--1HRhn";
export var wrapperNavPhone = "Header-module--wrapperNavPhone--1mwQh";